import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const AccountsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/financial/accounts/bankAccounts`);
    }
  }, [match]);

  return null;
};

export default AccountsPage;
